/**
 * this component shows read only questions
 * for the admin to see questionnaire or for
 * displaying via public link
 */

import React from 'react';
import {
  Box,
} from '@mui/material';
import NumberRangeQuestion from '../../questions/numberRange/NumberRangeQuestion';
import {
  DigitalQuestion,
  QuestionCaseSetting,
  QuestionTypeV2,
} from '../../../redux/types';
import MultiChoiceQuestion from '../../questions/multiChoice/MultiChoiceQuestion';
import SingleChoiceQuestion from '../../questions/singleChoice/SingleChoiceQuestion';
import StringQuestion from '../../questions/string/StringQuestion';
import RatioQuestion from '../../questions/ratio/RatioQuestion';
import ChoiceWithTextQuestion from '../../questions/choiceWithText/ChoiceWithTextQuestion';
import SingleChoiceWithTextQuestion from '../../questions/singleChoiceWithText/SingleChoiceWithTextQuestion';
import MultiChoiceWithTextQuestion from '../../questions/multiChoiceWithText/MultiChoiceWithTextQuestion';
import { CompulsoryCtxSettingMapType } from '../../../hooks/survey/usePendingCompulsoryCtxQuestions';

type Props = {
  questions: DigitalQuestion[];
  caseId?: number;
  settingsDictionary?: { get: (qId: number, cId: number) => QuestionCaseSetting | undefined };
  compulsoryCtxSettingMap?: CompulsoryCtxSettingMapType;
};

const QuestionInputFormPreview: React.FC<Props> = ({
  questions,
  caseId,
  settingsDictionary,
  compulsoryCtxSettingMap,
}: Props) => {
  let filteredQuestions = questions;
  if (settingsDictionary && caseId) {
    filteredQuestions = questions.filter((q) => !settingsDictionary.get(q.id, caseId)?.hide);
  }

  return (
    <Box sx={{ p: '1.5rem' }}>
      {
        filteredQuestions
          .map((q) => (
            <Box
              key={q.id}
              sx={{
                bgcolor: compulsoryCtxSettingMap?.[q.id]?.compulsory ? '#fdeded' : '',
              }}
            >
              <Box sx={{ py: '1.5rem' }}>
                {
                  q.type === QuestionTypeV2.NumberRange && (
                    <NumberRangeQuestion
                      mode="view"
                      question={q}
                    />
                  )
                }
                {
                  q.type === QuestionTypeV2.SingleChoice && (
                    <SingleChoiceQuestion
                      deprecated
                      mode="view"
                      question={q}
                    />
                  )
                }
                {
                  q.type === QuestionTypeV2.MultiChoice && (
                    <MultiChoiceQuestion
                      deprecated
                      mode="view"
                      question={q}
                    />
                  )
                }
                {
                  q.type === QuestionTypeV2.String && (
                    <StringQuestion
                      mode="view"
                      question={q}
                    />
                  )
                }
                {
                  q.type === QuestionTypeV2.Ratio && (
                    <RatioQuestion
                      mode="view"
                      question={q}
                    />
                  )
                }
                {
                  q.type === QuestionTypeV2.ChoiceWithText && (
                    <ChoiceWithTextQuestion
                      deprecated
                      mode="view"
                      question={q}
                      expand
                    />
                  )
                }
                {
                  q.type === QuestionTypeV2.SingleChoiceWithText && (
                    <SingleChoiceWithTextQuestion mode="view" question={q} expand />
                  )
                }
                {
                  q.type === QuestionTypeV2.MultiChoiceWithText && (
                    <MultiChoiceWithTextQuestion mode="view" question={q} expand />
                  )
                }
              </Box>
            </Box>
          ))
      }
    </Box>
  );
};

export default QuestionInputFormPreview;
